import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, Moon, Sun, Bell, MessageCircle } from 'lucide-react';
import SearchBar from '../components/SearchBar';
import NotificationDropdown from '../components/NotificationDropdown';
import UserDropdown from '../components/UserDropdown';

const Navbar = ({ onMenuClick, notifications = [], sidebarCollapsed }) => {
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('fosen_admin_theme') === 'dark');

  useEffect(() => {
    document.body.classList.toggle('admin-dark-mode', darkMode);
    localStorage.setItem('fosen_admin_theme', darkMode ? 'dark' : 'light');
    return () => document.body.classList.remove('admin-dark-mode');
  }, [darkMode]);

  const defaultNotifications = [
    { id: 1, title: 'New Order', message: 'Order #12345 placed', time: '2 mins ago', read: false },
    { id: 2, title: 'Low Stock', message: 'Sofa collection stock low', time: '1 hour ago', read: false },
    { id: 3, title: 'Review Posted', message: 'Customer left a review', time: '3 hours ago', read: true },
  ];

  return (
    <motion.nav
      initial={{ y: -72 }}
      animate={{ y: 0 }}
      className="sticky top-0 z-30 border-b border-[#e7dbc8]/40 bg-[#fff4ea]/95 backdrop-blur-xl shadow-sm"
    >
      <div className="flex h-16 sm:h-20 items-center justify-between gap-2 sm:gap-4 px-3 sm:px-6 lg:px-8">
        <div className="flex items-center gap-2 sm:gap-3 min-w-0">
          <button
            type="button"
            onClick={onMenuClick}
            className="inline-flex h-10 w-10 sm:h-11 sm:w-11 flex-shrink-0 items-center justify-center rounded-xl sm:rounded-2xl border border-[#dbcfb7] bg-[#fff9f1] text-[#4d3d2c] shadow-sm transition hover:bg-[#f4e5cc] lg:hidden"
            aria-label="Toggle sidebar"
          >
            <Menu size={20} />
          </button>

          <div className="flex flex-col justify-center min-w-0">
            <p className="text-[9px] sm:text-xs uppercase tracking-[0.2em] sm:tracking-[0.32em] text-[#7e6d54] truncate">Fosen Admin</p>
            <h1 className="text-sm sm:text-lg font-semibold text-[#2c200f] truncate leading-tight">Dashboard</h1>
          </div>
        </div>

        <div className="flex-1 max-w-md mx-2 hidden md:block">
          <SearchBar placeholder="Search products, orders, customers..." />
        </div>

        <div className="flex items-center gap-1.5 sm:gap-2 flex-shrink-0">
          <button
            onClick={() => setDarkMode((prev) => !prev)}
            className="inline-flex h-10 w-10 sm:h-11 sm:w-11 items-center justify-center rounded-xl sm:rounded-2xl border border-[#dbcfb7] bg-[#fff9f1] text-[#4d3d2c] shadow-sm transition hover:bg-[#f4e5cc]"
            aria-label="Toggle dark mode"
          >
            {darkMode ? <Sun size={18} /> : <Moon size={18} />}
          </button>

          <div className="block">
            <NotificationDropdown notifications={notifications.length > 0 ? notifications : defaultNotifications} />
          </div>

          <UserDropdown user={{ name: 'Admin User', email: 'admin@fosen.com' }} />
        </div>
      </div>
    </motion.nav>
  );
};

export default Navbar;
